import React, { useEffect, useRef, useState } from 'react';
import Button from './button';

const autosaveDelaySeconds = 1.5;

const SubmitBar = ({
  onCancel,
  onSubmit,
  submitLabel = 'Save',
  cancelLabel = 'Cancel',
  disableSubmit = false,
  disableCancel = false,
  hasAutosave = false,
  hasReset = false,
  hasChanged = false,
  startSaving = false,
  level = null,
  onStartedSaving = () => {},
  onReset = () => {},
}) => {
  const [percentage, setPercentage] = useState(0);
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);

  const autoSave = () => {
    clearInterval(intervalRef.current);
    onSubmit();
  };

  const startAutoSave = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setPercentage(prevPercentage => {
        if (prevPercentage < 100) {
          return prevPercentage + 1;
        }
        autoSave();
        return 100;
      });
    }, autosaveDelaySeconds * 10);
  };

  const startTimer = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      onStartedSaving();
      setPercentage(0);
      startAutoSave();
    }, 1500);
  };

  useEffect(() => {
    if (startSaving) {
      startTimer();
    }
  }, [startSaving]);

  useEffect(() => {
    if (level === null || disableSubmit || hasReset) {
      return;
    }
    if (percentage > 0 && percentage < 100) {
      setPercentage(1);
      return;
    }
    startTimer();
  }, [level]);

  const renderAutosave = () => {
    return (
      <div className="tracker-footer">
        <div className="tracker-footer__buttons">
          {(percentage > 0 && percentage < 100 && !disableSubmit) > 0 ? (
            <button className="autosave-button">
              <span
                className="autosave-button__progress"
                style={{ width: `${percentage}%` }}></span>
              <span className="autosave-button__title">Saving</span>
            </button>
          ) : hasReset ? (
            <Button
              className="button button__secondary100-inverted button__btn-14-600 button-rectangle-skin-footer"
              onClick={onReset}
              text={'Reset'}
            />
          ) : null}
        </div>
      </div>
    );
  };

  const renderReset = () => {
    return (
      <div className="tracker-footer">
        <div className="tracker-footer__buttons">
          <Button
            className="button button__secondary100-inverted button__btn-14-600 button-rectangle-skin-footer"
            onClick={onReset}
            text={'Reset'}
          />
        </div>
      </div>
    );
  };

  if (hasAutosave) {
    return renderAutosave();
  }

  if (hasReset) {
    return renderReset();
  }

  return (
    <div className="tracker-footer">
      <div className="tracker-footer__buttons tracker-footer__buttons--small"></div>
      <div className="tracker-footer__buttons tracker-footer__buttons--small">
        {hasChanged && (
          <>
            <Button
              className="button button__secondary100-inverted no-border button__btn-14-600 button-rectangle-skin-footer"
              onClick={onCancel}
              text={cancelLabel}
              disabled={disableCancel}
            />
            <Button
              onClick={onSubmit}
              className="button button__secondary100 button__btn-14-600 button-rectangle-skin-footer"
              text={submitLabel}
              disabled={disableSubmit}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SubmitBar;
